<template>
    <div v-if="isFacilityAssigned">
        <!-- facility name (non-multi account) -->
        <span v-if="!isMultiFacility" class="font-weight-normal subtitle-2 primary--text text--capitalize">{{ getFacilityName }}</span>
        <!-- multiple facility selection (multi account) -->
        <v-menu v-if="isMultiFacility"
            transition="scale-transition"
            offset-x
            bottom
            dense>
            <template v-slot:activator="{ on: menu }">
                <v-tooltip bottom color="primary" dark>
                    <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                            v-on="{ ...tooltip, ...menu }"
                            color="primary"
                            dark text>
                            <span class="font-weight-normal subtitle-2 primary--text" style="text-transform: none;">{{ getFacilityName }}</span>
                            <v-icon width="6">mdi-menu-down</v-icon>
                        </v-btn>
                    </template>
                    <span>Change Facility</span>
                </v-tooltip>
            </template>
            <v-list>
                <v-list-item>
                    <v-list-item-avatar>
                        <v-icon color="primary" large>mdi-office-building</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title class="primary--text"><small>Current:</small><br/>{{ getFacilityName }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                    </v-list-item-action>
                </v-list-item>
            </v-list>
            
            <v-divider></v-divider>

            <v-list>
                <template v-for="(item, index) in getFacilities">
                    <v-list-item v-if="item.description != getFacilityName"
                        :key="index"
                        @click="changeFacility(item)">
                        <v-list-item-title>
                            <v-icon color="orange darken-2" size="12" class="mr-1">mdi-circle</v-icon>
                            {{ item.description }}
                        </v-list-item-title>
                    </v-list-item>
                </template>
            </v-list>
        </v-menu>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: 'AppFacilitySelector',
    props: {
      drawer: Boolean
  },
  computed: {
    // the spread operator allows to merge these mappers with other local computed properties
    ...mapGetters([
      'isFacilityAssigned',
      'isMultiFacility',
      'getFacilities',
      'getFacilityName',
    ])
  },
  methods: {
    changeFacility(facility) {
      this.$store.dispatch('changeFacility', { facility: facility })
    }
  }
}
</script>
